const scroll = element => {
  const top = element.offsetTop - element.parentNode.offsetTop;

  element.parentNode.scrollTop = top;
};

export { scroll };
